import user from 'apps/ddo/models/user';
import designCollection from 'apps/ddo/models/designCollection';
import design from 'apps/ddo/models/design';
import designComment from 'apps/ddo/models/designComment';
import designCommentCollection from '@99designs/common/apps/ddo/models/designCommentCollection';

export default {
    user,
    designCollection,
    designComment,
    design,
    designCommentCollection,
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/di.js